var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:{'lg': _vm.spinnerSize === 'large', 'sm': _vm.spinnerSize === 'small'}},[_vm._v("Loading...")])}
var staticRenderFns = []

export { render, staticRenderFns }